const debounce = require('throttle-debounce/debounce');
const verge = require('verge');

const laptop = 1240,
	tabletHorizontal = 1024,
	tabletVertical = 768,
	mobile = 480;

function inWidth(maxWidth = tabletHorizontal, minWidth = 0) {
	let currentWidth = verge.viewportW();
	if (maxWidth >= currentWidth && minWidth < currentWidth) {
		return true;
	} else {
		return false;
	}
}

// google maps on Contacts page
const gmapsOption = {};
gmapsOption.styles = [
	{
		featureType: 'all',
		elementType: 'geometry.fill',
		stylers: [
			{
				weight: '2.00'
			}
		]
	},
	{
		featureType: 'all',
		elementType: 'geometry.stroke',
		stylers: [
			{
				color: '#9c9c9c'
			}
		]
	},
	{
		featureType: 'all',
		elementType: 'labels.text',
		stylers: [
			{
				visibility: 'on'
			}
		]
	},
	{
		featureType: 'landscape',
		elementType: 'all',
		stylers: [
			{
				color: '#f2f2f2'
			}
		]
	},
	{
		featureType: 'landscape',
		elementType: 'geometry.fill',
		stylers: [
			{
				color: '#ffffff'
			}
		]
	},
	{
		featureType: 'landscape.man_made',
		elementType: 'geometry.fill',
		stylers: [
			{
				color: '#ffffff'
			}
		]
	},
	{
		featureType: 'poi',
		elementType: 'all',
		stylers: [
			{
				visibility: 'off'
			}
		]
	},
	{
		featureType: 'road',
		elementType: 'all',
		stylers: [
			{
				saturation: -100
			},
			{
				lightness: 45
			}
		]
	},
	{
		featureType: 'road',
		elementType: 'geometry.fill',
		stylers: [
			{
				color: '#eeeeee'
			}
		]
	},
	{
		featureType: 'road',
		elementType: 'labels.text.fill',
		stylers: [
			{
				color: '#7b7b7b'
			}
		]
	},
	{
		featureType: 'road',
		elementType: 'labels.text.stroke',
		stylers: [
			{
				color: '#ffffff'
			}
		]
	},
	{
		featureType: 'road.highway',
		elementType: 'all',
		stylers: [
			{
				visibility: 'simplified'
			}
		]
	},
	{
		featureType: 'road.arterial',
		elementType: 'labels.icon',
		stylers: [
			{
				visibility: 'off'
			}
		]
	},
	{
		featureType: 'transit',
		elementType: 'all',
		stylers: [
			{
				visibility: 'off'
			}
		]
	},
	{
		featureType: 'water',
		elementType: 'all',
		stylers: [
			{
				color: '#46bcec'
			},
			{
				visibility: 'on'
			}
		]
	},
	{
		featureType: 'water',
		elementType: 'geometry.fill',
		stylers: [
			{
				color: '#c8d7d4'
			}
		]
	},
	{
		featureType: 'water',
		elementType: 'labels.text.fill',
		stylers: [
			{
				color: '#070707'
			}
		]
	},
	{
		featureType: 'water',
		elementType: 'labels.text.stroke',
		stylers: [
			{
				color: '#ffffff'
			}
		]
	},
	{
		"featureType": "transit.station.airport",
		"stylers": [
			{
				"visibility": "on"
			}
		]
	}
];

var GoogleMapsLoader = require('google-maps');
GoogleMapsLoader.KEY = 'AIzaSyAx6qgWKdufKR1BnK6vvzamjC9Av8TqMio';
GoogleMapsLoader.LANGUAGE = 'en';
var is_internetExplorer11 = navigator.userAgent.toLowerCase().indexOf('trident') > -1;
var marker_url = (is_internetExplorer11) ? '/images/out_png/marker.png' : '/images/out_svg/marker.svg';

if ($('.js-contacts__map').length) {
	GoogleMapsLoader.load(function (google) {
		$('.js-contacts__map').each(function (i, element) {
			let coord = element.getAttribute('data-coordinates').split(', ');
			let coordCenter = element.getAttribute('data-center').split(', ');
			let mapCenter;

			if (inWidth(tabletHorizontal)) {
				mapCenter = new google.maps.LatLng(coord[0], coord[1]);
			} else {
				mapCenter = new google.maps.LatLng(coordCenter[0], coordCenter[1]);
			}

			let mapOptions = {
				zoom: 13,
				disableDefaultUI: true,
				zoomControl: true,
				scaleControl: true,
				center: mapCenter,
				styles: gmapsOption.styles
			};

			let map = new google.maps.Map(element, mapOptions);

			let marker = new google.maps.Marker({
				position: new google.maps.LatLng(coord[0], coord[1]),
				map: map,
				title: element.getAttribute('data-title'),
				visible: true,
				icon: marker_url
			});

			google.maps.event.addDomListener(window, 'resize', function () {
				if (inWidth(tabletHorizontal)) {
					mapCenter = new google.maps.LatLng(coord[0], coord[1]);
				} else {
					mapCenter = new google.maps.LatLng(coordCenter[0], coordCenter[1]);
				}
				google.maps.event.trigger(map, 'resize');
				map.setCenter(mapCenter);
			});

		});
	});
}


// forms modal colorbox
$('.js-form__modal').colorbox({
	inline: true,
	fixed: true,
	width: '80%',
	maxWidth: '1240px',
	maxHeight: '95%',
	className: 'form__modal',
	onComplete: function () {
		$('#cboxPrevious').attr('title', 'Prev');
		$('#cboxNext').attr('title', 'Next');
		$('#cboxClose').attr('title', 'Close');

		initValidationForms();

		$('.js-form').on('submit', debounce(300, function (e) {
			$.colorbox.resize({
				width: '80%',
				maxWidth: '1240px'
			});
		}));
	}
});



// WEBPACK FOOTER //
// ./frontend/components/contacts-map/contacts-map.js